// extracted by mini-css-extract-plugin
module.exports = {"image":"NotAllowed_image__1OWGh","innerContainer":"NotAllowed_innerContainer__2AP7J","button":"NotAllowed_button__2Fjf7"};